var _a;
import { generateSelectors } from "../generators/generator.selectors";
import { GENERATOR_PARAMS, REDUCER_KEY } from "./report.beneficiary.constants";
export var getPaged = (_a = generateSelectors(GENERATOR_PARAMS), _a.getPaged), getCount = _a.getCount, getAllRaw = _a.getAllRaw;
